<template lang="pug">
el-form(ref="form" size="small" :model="form" inline)
  el-form-item(v-if="showPrjSelect" label="所属项目")
    el-select(v-model="form.prjId" size="small" clearable filterable )
      el-option(v-for="item in approvalProjectList" :key="item.prjId" :label="item.prjCode+'-'+item.prjName" :value="item.prjId")
  el-form-item(label="流程名称")
    el-select(v-model="form.flowType" size="small" clearable)
      el-option(v-for="item in definitionList" :key="item.flowDefinitionId" :label="item.flowName" :value="item.flowDefinitionId")
  el-form-item(label="关键字查询")
    el-input(v-model="form.keywords" size="small" placeholder="标题/内容/申请人/审批人" clearable)
  el-form-item(v-if="showApplicantSelect" label="申请人")
    el-select(v-model="form.flowInstanceOwnerId" size="small" clearable)
      el-option(v-for="item in userList" :key="item.flowInstanceOwnerID" :value="item.flowInstanceOwnerID"
        :label="item.flowInstanceOwnerName+'('+item.flowInstanceOwnerUserName+')'")
  el-form-item(v-if="showStatusSelect" label="审批状态")
    el-select(v-model="form.status" size="small" clearable)
      el-option(v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value")
  el-form-item(label="申请时间")
    el-date-picker(v-model="form.approveTime" type="daterange" value-format="yyyy-MM-dd"
      range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" size="small")
  el-form-item
    el-button(size="small" type="primary" @click="handleQueryBtnClick") 查 询
    el-button(size="small" type="primary" plain @click="resetFormBtnHandle") 重 置
</template>

<script>
import { mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import { FLOW_INSTANCE_STATUS_DICT } from "@/CommonDP/components/processComponents/config";

const newForm = () => ({
  prjId: "",
  flowInstanceOwnerId: "",
  approveTime: "",
  flowType: "",
  keywords: "",
  status: null
});
export default {
  props: {
    // 是否有项目选择框
    showPrjSelect: {
      type: Boolean,
      default: true
    },
    // 是否申请人
    showApplicantSelect: {
      type: Boolean,
      default: true
    },
    // 是否有审批状态选择框
    showStatusSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: newForm(),
      approvalProjectList: [],
      userList: [],
      definitionList: [],
      statusList: FLOW_INSTANCE_STATUS_DICT
    };
  },
  computed: {
    ...mapState({
      prjId: (state) => state.projectMg.prjId,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted () {
    this.getInit();
  },
  methods: {
    // 查询初始化
    getInit() {
      this.getDefinitionList();
      if (this.showPrjSelect) {
        this.getProjects();
      }
      if (this.showApplicantSelect) {
        this.getUserList();
      }
    },
    // 查询项目列表
    async getProjects() {
      const query = { enterpriseId: this.enterpriseId };
      const res = await flowService.queryApplicantProjects(query);
      this.approvalProjectList = res.data || [];
    },
    // 查询申请人
    async getUserList() {
      const res = await flowService.workbenchApplicant(this.enterpriseId);
      this.userList = res.data || [];
    },
    // 查询流程类型
    async getDefinitionList() {
      const res = await flowService.downList(this.enterpriseId);
      this.definitionList = res.data || [];
      this.definitionList.sort((a, b) => {
        return (a['flowName'] || "").localeCompare(b['flowName']);
      });
    },
    // 接口：获取表单的数据
    getForm() {
      const approveTime = this.form.approveTime || [];
      const params = {
        ...this.form,
        startDate: approveTime[0] || "",
        endDate: approveTime[1] || "",
        prjId: this.showPrjSelect ? this.form.prjId : "",
        enterpriseId: this.enterpriseId
      };
      return params;
    },
    resetForm() {
      this.form = newForm();
    },
    // 查询
    handleQueryBtnClick() {
      this.$emit("change", this.getForm());
    },
    resetFormBtnHandle() {
      this.form = newForm();
      this.$emit("change", this.getForm());
    }
  }
};
</script>

<style lang="scss" scoped></style>
